import { mapGetters } from 'vuex'
import IndexedDBService from '@/helpers/IndexedDBService'

export default {
  data() {
    return {
      typeLocalSettings: {
        'tenders.mini': 'Згорнутий режим меню на сторінці тендерів',
        'purchasings.mini': 'Згорнутий режим меню на сторінці закупівель',
        'purch_menuType': 'Обране меню на сторінці закупівель',
        'stopLists_menuType': 'Обране меню на сторінці стоп-листів',
        'suppliers_menuType': 'Обране меню на сторінці постачальників',
        'additionalFieldPage_menuType': 'Обране меню на сторінці додаткових полів',
        'tenders_menuType': 'Обране меню на сторінці тендерів',
        'automationPage_menuType': 'Обране меню на сторінці автоматизації',
        'notificationPage_menuType': 'Обране меню на сторінці повідомлень',
        'orgSettings_menuType': 'deprecate: Обране меню на сторінці налаштувань організацій',
        'tenders_tableMode': 'Табличний режим відображення тендерів',
        'filters-template_tour': 'Навчальний тур по шаблонам фільтрів',
        'rejectDialog_tour': 'Навчальний тур за формою відхилення',
        'download-files_tour.finish': 'Навчальний тур завантаженя файлів (початок)',
        'download-files_tour.start': 'Навчальний тур завантаженя файлів (завершення)',
        'confirmTenderAgreement_tour': 'Навчальний тур по формі узгодження',
        'feedBtn': 'Позиції кнопки обратного зв\'язку',
        'download-files.list': 'Перелік файлів очікуючих завантаження',
        'tenders_headers': 'Обрані для відображення колонки на сторінці тендерів',
        'tenders_groupType': 'Обране группування на сторінці тендерів',
        'tenders_filters': 'Збережені фільтри сторінки тендерів',
        'purchasing_filters': 'Збережені фільтри сторінки замовлень',
        'planning_filters': 'Збережені фільтри сторінки планів закупівель',
        'orgSettings_pageProp': 'Налаштування сторінки налаштувань організацій',
        'godMode_tour': 'Переїзд перемикача режиму адміна',
        'user-theme': 'Кольорова тема сайту'
      }
    }
  },
  computed: {
    ...mapGetters({
      storedCurrentOrganization: 'getCurrentOrganization',
      cur_user: 'GET_USER',

    }),
    ...mapGetters('dbStore', ['allDbStore', 'loadedAllDbStore']),
    $_loadedAllDbStore() {
      return this.loadedAllDbStore
    },
    $_storageRouteName() {
      let route = this.$route.name
      const routeWithFilters = ['purchasing', 'planning', 'tenders', 'suppliers', 'organizerSettings']
      if ( routeWithFilters.includes(route) ) {
        return route
      }
    },
    $_currentUser() {
      return (this.cur_user?.login || '').toLowerCase()
    }
  },
  methods: {
    /**
     * Сохранение фильтров в хранилище
     * @param {Object} param
     */
    async $_saveFiltersToDBStorage({filters, filters_mode, search, type}) {
      return new Promise(async (resolve, reject) => {
        if (!this.$_storageRouteName) { resolve() }
        try {
          const key = `${this.$_storageRouteName}_filters`
          await this.$_getFiltersFromDBStorage(key)
            .then(async (older) => {
              older = older && typeof older === 'string' ? JSON.parse(older) : older
              let info_obj = {
                filters: filters ?? older?.filters,
                filters_mode: filters_mode ?? older?.filters_mode ,
                search: search ?? older?.search,
                type: type || older?.type
              }
              await this.$_setDBStorage(key, info_obj)
                .then(async(qraphResult) => {
                  await this.$store.dispatch('dbStore/setStoreProp', {key, value: info_obj })
                  resolve(qraphResult)
                }).catch(error => {
                  reject(error)
                })
            })
        } catch (error) {
          reject(error)
        }
      })
    },
    /**
     * Получение фильтров из хранилища
     * @returns
     */
    async $_getFiltersFromDBStorage(innerKey) {
      return new Promise(async (resolve) => {
        if (!this.$_storageRouteName) {
          resolve({
            filters: [],
            filters_mode: true
          })
        }
        try {
          const key = innerKey || `${this.$_storageRouteName}_filters`
          await this.$_getPropFromDBStorage(key)
            .then(async result => {
              resolve(result || {})
            })
        } catch {
          resolve({})
        }
      })
    },
    /**
     *
     * @param {*} byUser - Выбираем по конкретному пользователю
     * @returns
     */
    $_getStorageFilters(byUser) {
      if (this.$_storageRouteName) {
        const key = byUser ? `${this.$_currentUser}_filters` : 'filters'

        let info = sessionStorage.getItem(`${key}: ${ this.$_storageRouteName }`)
        return JSON.parse( info ) || {}
      }
    },
    /**
     * Получение значение ключа из объекте
     * или
     * Установка значения ключа по текстовому пути (при указанном value)
     * @param {Object} object исходный объект
     * @param {String} path текстовый путь к свойству
     * @param {*} value Значение
     */
    $_objectPropByPath(object, path, value) {
      try {
        path = typeof path === 'string' ? path.split('.') : path
        if (!object || !path || !path.length) { return }
        let current = object
        while (path.length > 1) {
          const [head, ...tail] = path
          path = tail
          if (current[head] === undefined) {
            current[head] = {}
          }
          current = current[head]
        }
        if (value !== undefined) {
          current[path[0]] = value
          return object
        }
        return current[path[0]]
      } catch (_) { /*null*/ }
    },
    /**
     * Ключ настроек организации в localStorage
     * @returns String
     */
    $_getSettingKey(byUser) {
      const key = byUser ? this.$_currentUser : this.storedCurrentOrganization?.organizationItId
      if (!key) {
        return null
        // throw new Error('Org route params not find')
      }
      return `${key}_settings`
    },
    $_deleteObjectPropByPath(object, path) {
      try {
        const keys = typeof path === 'string' ? path.split('.') : path
        if (!object || !keys || !keys.length) { return }

        let current = object
        while (keys.length > 1) {
          const head = keys.shift()
          if (current[head] === undefined || current[head] === null) {
            return
          }
          current = current[head]
        }

        const lastKey = keys[0]
        if (lastKey in current) {
          delete current[lastKey]
          return object
        }
      } catch (error) {
        return
      }
    },
    /**
     * Удаление значения из локального хранения
     * @param {String} path  Путь свойства
     * @param {Boolean} byUser По пользователю
     * @returns
     */
    $_deletePropFromLocalStorage(path, byUser) {
      if (!path) { return }

      try {
        const key = this.$_getSettingKey(byUser)
        if (!key) { return }

        let settings = localStorage.getObject(key) || {}
        if (typeof settings !== 'object' || Array.isArray(settings)) {
          return
        }

        settings = this.$_deleteObjectPropByPath(settings, path) || settings

        localStorage.setItem(key, JSON.stringify(settings))
      } catch (error) {
        return
      }
    },
    /**
     * Получить настройку из localStorage
     * @param {String} path  Путь свойства
     * @param {Boolean} byUser По пользователю
     * @param {*} default Значение по умолчанию
     * @returns
     */
    $_getPropFromLocalStorage(path, defaultValue, byUser) {
      try {
        const key = this.$_getSettingKey(byUser)
        if (!key) { return defaultValue }

        return this.$_parseResult(localStorage.getObject(key) || {}, path, defaultValue)
      } catch {
        return defaultValue
      }
    },
    /**
     * Сохранить настройку в localStorage
     * @param {String} path Путь свойства
     * @param {Boolean} byUser По пользователю
     * @param {*} value Значение свойства
     */
    $_savePropToLocalStorage(path, value, byUser) {
      if (!path) { return }
      try {
        const key = this.$_getSettingKey(byUser)

        let settings = localStorage.getObject(key) || {}
        if (typeof settings !== 'object' || Array.isArray(settings)) {
          settings = {}
        }

        settings = this.$_objectPropByPath(settings, path, value)
        localStorage.setItem(key, JSON.stringify(settings))
      } catch {
        return
      }
    },
    /**
     * Разбираем сохраненную модель
     * @param {*} value модель
     * @param {*} path путь
     * @param {*} defaultValue значение по умолчанию
     * @returns
     */
    $_parseResult(value, path, defaultValue) {
      if (!value) { return defaultValue }

      if (typeof path === 'string' && path.includes(':')) {
        path = path.replace(/:/, '.')
      }

      const propValue = this.$_objectPropByPath(value, path)
      return propValue !== undefined ? propValue : defaultValue
    },
    /**
     * Получить настройку из базы
     * @param {String} key Ключ настройки
     * @param {String} defaultValue Значение по умолчанию
     * @param {Boolean} useCashe использовать ли значение из стора
     * @returns
     */
    async $_getPropFromDBStorage(key, defaultValue, useCashe = true) {

      if (useCashe && this.allDbStore.hasOwnProperty(key)) {
        return this.allDbStore[key] || defaultValue
      }
      try {
        const result = await IndexedDBService.getItem(IndexedDBService.storeNames.itemProps, key, defaultValue)
        let value = defaultValue
        try {
          value = JSON.parse(result) || defaultValue
        } catch {
          value = defaultValue
        }
        if (useCashe) {
          this.$store.dispatch('dbStore/setStoreProp', {key, value})
        }
        return value
      } catch {
        return defaultValue
      }
    },
    /**
     * Сохранить настройку в базу
     * @param {String} key Ключ настройки
     * @param {String} value Значение
     * @param {Date} expiresAt Срок истечения настройки
     * @param {Boolean} useCashe использовать ли значение из стора
     */
    async $_savePropToDBStorage(key, value, expiresAt, useCashe = true) {
      if (this.allDbStore?.[key] === value) {
        return new Promise((resolve) => resolve())
      }

      return new Promise(async (resolve, reject) => {
        try {
          await this.$_setDBStorage(key, value, expiresAt)
            .then(async(qraphResult) => {
              if (useCashe) { await this.$store.dispatch('dbStore/setStoreProp', {key, value }) }
              resolve(qraphResult)
            }).catch(error => {
              reject(error)
            })
        } catch (error) {
          reject(error)
        }
      })
    },
    async $_deletePropFromDBStorage(key) {
      if (!key) { return }
      await this.$store.dispatch('dbStore/deleteStoreProp', {key})
      try {
        await this.$_deleteDBStorage(key)
      } catch { return }
    },
    $_setDBStorage(key, value, expiresAt) {
      if (!IndexedDBService.dbName) {
        return Promise.resolve()
      }
      try {
        value = JSON.stringify(value)
        if (this.allDbStore.hasOwnProperty(key) && this.allDbStore[key] && this.$_.isEqual(this.allDbStore[key], value)) {
          return new Promise((resolve) => resolve())
        }

        expiresAt = expiresAt && typeof expiresAt === 'number' ? new Date(expiresAt).toISOString() : null
        return Promise.all([
          IndexedDBService.setItem(IndexedDBService.storeNames.itemProps, {key, value, expiresAt}),
          IndexedDBService.setItem(IndexedDBService.storeNames.changedKeys, {key, state: 'update'})
        ])
      } catch (_) {
        return
      }
    },
    $_deleteDBStorage(key) {
      return Promise.all([
        IndexedDBService.deleteItem(IndexedDBService.storeNames.itemProps, key),
        IndexedDBService.setItem(IndexedDBService.storeNames.changedKeys, {key, state: 'delete'})
      ])
    }
  },
}
